import { useEffect, useState } from "react";

export function getCssVariable(
  name: string,
  from: HTMLElement = document.body,
): string {
  return getComputedStyle(from).getPropertyValue(name).trim();
}

export function useCSSVariable(
  variable: string,
  element: HTMLElement = document.body,
): string {
  const [color, setColor] = useState<string>(() =>
    getCssVariable(variable, element),
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const newColor = getCssVariable(variable, element);
      setColor(newColor);
    });

    observer.observe(element, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect();
  }, [variable, element]);

  return color;
}
